
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"502","height":"322","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M341 322c88.918 0 161-72.082 161-161S429.918 0 341 0c-43.868 0-83.638 17.545-112.677 46H15C6.716 46 0 52.716 0 61v201c0 8.284 6.716 15 15 15h214.353c28.945 27.866 68.295 45 111.647 45z","fill":"#0A0A0A","fill-opacity":".4"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M494 161c0 84.5-68.5 153-153 153-42.345 0-80.672-17.202-108.374-45H14a6 6 0 01-6-6V96a6 6 0 016-6h191.436C231.02 41.252 282.127 8 341 8c84.5 0 153 68.5 153 153z","fill":"#0A0A0A","fill-opacity":".4"}})])
          )
        }
      }
    